import { ToastType } from '../constants';

export interface IToast {
  id: number;
  type: ToastType;
  message: string;
  title?: string;
}

export class Toast implements IToast {
  id: number;

  constructor(public type: ToastType, public message: string, public title?: string) {
    this.id = Toast.getUniqID();
  }

  private static getUniqID(): number {
    return +new Date();
  }
}
